<template>
	<div>
		<firstsceenimage title="新闻中心" subtitle="News Center" :imgobj='bannerimage'></firstsceenimage>
		<div class="container">
			<!-- 导航栏 -->
			<div style="display: flex; font-size:15px; margin-top: -50px;">
				<div :class="[selectindex==0? 'tabaction':'tabitem']"
					style="font-weight: 400;text-align: center;margin-right:50px ;" @click="selecttab(0)">
					<div>企业动态</div>
					<div
						style="width: 32px;border-bottom: 2px solid ; margin-left: auto;margin-right: auto;margin-top: 7px;">
					</div>
				</div>
				<div :class="[selectindex==1? 'tabaction':'tabitem']" style="font-weight: 400;text-align: center;"
					@click="selecttab(1)">
					<div>行业咨询</div>
					<div
						style="width: 32px;border-bottom: 2px solid ;margin-left: auto;margin-right: auto;margin-top: 7px;">
					</div>
				</div>
			</div>
			<!-- 导航栏 end-->
			<div style="height: 40px;"></div>
			<!-- 内容1 -->
			<div v-if="selectindex==0">
				<div class="flexcenter" style="border-bottom: 2px solid #EAEAEA;margin-bottom: 15px;"
					v-on:click="gopage('/news/details/1')">
					<div class="col-md-7 " style="height: 274px;padding-right: 40px;">
						<div style="color: #999999;font-size: 14px;"> 2022-04-01</div>
						<div style="color:#333333;font-size: 24px;margin-top: 22px;">
							时尚产业迎来数字化春天 星链联合华为共同助力中国时尚产业数字化
						</div>
						<div style="color:#666666;font-size: 14px;margin-top: 17px;">
							2022年1月7日上午，浙江星链数据科技有限公司与华为云计算技术有限公司在深圳华为总部签署了“AI数字时尚产业联合创新项目合作协议”，双方通过运用互联网、AI大数据、人工智能技术，基于华为云AI盘古大模型技术和星链C2M数字化产业解决方案，为传统产业提供数字化整体解决方案....
						</div>
					</div>
					<div class="col-md-4">
						<img style=" height: 202px; margin-top: 30px;" src="../../static/news/鞋业“奥斯卡”落户上海CHIC 奥云数据荣获“年度鞋履产业创新者”大奖.png" />
					</div>
				</div>

				<div class="flexcenter" style="border-bottom: 2px solid #EAEAEA;margin-bottom: 15px;"
					v-on:click="gopage('/news/details/2')">
					<div class="col-md-7 " style="height: 274px;padding-right: 40px;">
						<div style="color: #999999;font-size: 14px;"> 2022-04-01</div>
						<div style="color:#333333;font-size: 24px;margin-top: 22px;">
							新战略·星启程星链数据2021年度成绩单</div>
						<div style="color:#666666;font-size: 14px;margin-top: 17px;">
							充满机遇和挑战的2021年，也是星链硕果满满的一年。1月24日，星链[新征程·星启航]年度工作述职会
							议在奥康知行厅展开，为2021年画上圆满的句号。
						</div>
					</div>
					<div class="col-md-4">
						<img style="height: 202px;margin-top: 30px;" src="../../static/news/新战略·星启程星链数据2021年度成绩单.png" />
					</div>
				</div>

				<div class="flexcenter" style="border-bottom: 2px solid #EAEAEA;margin-bottom: 15px;"
					v-on:click="gopage('/news/details/3')">
					<div class="col-md-7 " style="height: 274px;padding-right: 40px;">
						<div style="color: #999999;font-size: 14px;"> 2022-04-01</div>
						<div style="color:#333333;font-size: 24px;margin-top: 22px;">
							星链C2M赋能鞋业突围</div>
						<div style="color:#666666;font-size: 14px;margin-top: 17px;">
							浙江星链数据科技有限公司（简称星链数据）将互联网、大数据、云计算、人工智能等新一代信息
							技术与制造业、零售业深度融合，探索C2M
							智能定制平台模式，为鞋业从制造端到零售终端的全产业链赋能，助力鞋企由标准化批量生产向个性化按需生产转变。 </div>
					</div>
					<div class="col-md-4">
						<img style="height: 202px;margin-top: 30px;" src="../../static/news/星链C2M赋能鞋业突围.png" />
					</div>
				</div>

				<div class="flexcenter" style="border-bottom: 2px solid #EAEAEA;margin-bottom: 15px;"
					v-on:click="gopage('/news/details/4')">
					<div class="col-md-7 " style="height: 274px;padding-right: 40px;">
						<div style="color: #999999;font-size: 14px;"> 2022-04-01</div>
						<div style="color:#333333;font-size: 24px;margin-top: 22px;">
							星链联合华为共同助力中国时尚产业数字化</div>
						<div style="color:#666666;font-size: 14px;margin-top: 17px;">
							2022年1月7日上午，浙江星链数据科技有限公司与华为云计算技术有限公司在深圳华为总部签署了“AI数
							字时尚产业联合创新项目合作协议”，双方通过运用互联网、AI大数据、人工智能技术，基于华为云AI盘
							古大模型技术和星链C2M数字化产业解决方案，为传统产业提供数字化整体解决方案，助力时尚产业数字
							化发展，共同构建数字时尚产业互联网新生态....
						</div>
					</div>
					<div class="col-md-4">
						<img style="height: 202px;margin-top: 30px;" src="../../static/news/星链联合华为共同助力中国时尚产业数字化.png" />
					</div>
				</div>
			</div>
			<!-- 内容1 end-->
			<!-- 内容2 -->
			<div v-if="selectindex==1">
				<div class="flexcenter" style="border-bottom: 2px solid #EAEAEA;margin-bottom: 15px;"
					v-on:click="gopage('/news/details/4')">
					<div class="col-md-7 " style="height: 274px;padding-right: 40px;">
						<div style="color: #999999;font-size: 14px;"> 2022-04-01</div>
						<div style="color:#333333;font-size: 24px;margin-top: 22px;">
							星链联合华为共同助力中国时尚产业数字化</div>
						<div style="color:#666666;font-size: 14px;margin-top: 17px;">
							2022年1月7日上午，浙江星链数据科技有限公司与华为云计算技术有限公司在深圳华为总部签署了“AI数字时尚产业联合创新项目合作协议”，双方通过运用互联网、AI大数据、人工智能技术，基于华为云AI盘古大模型技术和星链C2M数字化产业解决方案，为传统产业提供数字化整体解决方案，助力时尚产业数字化发展，共同构建数字时尚产业互联网新生态
						</div>
					</div>
					<div class="col-md-4">
						<img style="height: 202px;" src="../../static/news/星链联合华为共同助力中国时尚产业数字化.png" />
					</div>
				</div>
			</div>
			<!-- 内容2 end-->
		</div>
	</div>
</template>
<script>
	import firstsceenimage from '../../components/firstsceenimagecenter.vue'
	import bannerimage from '../../static/新闻中心.png'

	export default {
		name: 'Newdetails',
		components: {
			firstsceenimage,

		},
		data() {
			return {
				bannerimage: bannerimage,
				selectindex: 0,
			}
		},
		methods: {
			selecttab: function(e) {
				this.selectindex = e
			},
			gopage: function(url) {
				document.documentElement.scrollTop = 0;
				this.$router.push(url)

			},
		}

	}
</script>

<style>
	.tabaction {
		color: #E8C570;
	}

	.tabitem {
		color: white;
	}
</style>
